import { all, call } from "redux-saga/effects";
import onCreateQuizathon from "./createQuizathon"
import onEditQuizathon from "./editQuizathon";
import onGetQuizathonList from "./getQuizathonList";
import onGetSingleQuizathon from "./getSingleQuizathon";
import onGetQuizathonParticipants from "./getParticipants";
import onGetSingleParticipant from "./getSingleParticipant";
import onGetParticipantLeaderboard from "./getParticipantLeaderboard";
export default function* quizathonSaga() {
  yield all([
    call(onGetQuizathonList),
    call(onCreateQuizathon),
    call(onEditQuizathon),
    call(onGetQuizathonParticipants),
    call(onGetSingleQuizathon),
    call(onGetSingleParticipant),
    call(onGetParticipantLeaderboard)
  ]);
}
